import accountCurrencyIcon from "@/assets/figma/card-menu/account-currency.svg";
import accountLanguageIcon from "@/assets/figma/card-menu/account-language.svg";
import accountLogoutIcon from "@/assets/figma/card-menu/account-logout.svg";
import accountNotificationsIcon from "@/assets/figma/card-menu/account-notifications.svg";
import accountPackageProgress from "@/assets/figma/card-menu/account-package-progress.svg";
import accountRechargeProgress from "@/assets/figma/card-menu/account-recharge-progress.svg";
import accountSettingsIcon from "@/assets/figma/card-menu/account-settings.svg";
import accountSupportIcon from "@/assets/figma/card-menu/account-support.svg";
import accountTopupIcon from "@/assets/figma/card-menu/account-topup.svg";
import storeAdsIcon from "@/assets/figma/card-menu/store-ads.svg";
import storeAvatar from "@/assets/figma/card-menu/store-avatar.png";
import storeCountry from "@/assets/figma/card-menu/store-country.png";
import storeManageIcon from "@/assets/figma/card-menu/store-manage.svg";
import storePlatform from "@/assets/figma/card-menu/store-platform.png";
import storeTasksIcon from "@/assets/figma/card-menu/store-tasks.svg";
import storeTeamIcon from "@/assets/figma/card-menu/store-team.svg";
import widgetArrowRight from "@/assets/figma/card-menu/widget-arrow-right.svg";
import widgetEditIcon from "@/assets/figma/card-menu/widget-edit.svg";
import widgetLayoutIcon from "@/assets/figma/card-menu/widget-layout.svg";
import widgetRemoveIcon from "@/assets/figma/card-menu/widget-remove.svg";
import type { MerryCardMenuCatalog } from "@/shared/ui/MerryCardMenu";

const createStore = (
  id: string,
  tone: "danger" | "default" | "sync" | "todo",
  statusLabel: string,
) => ({
  avatarSource: storeAvatar,
  countrySource: storeCountry,
  id,
  platformLabel: "TikTok Shop",
  platformSource: storePlatform,
  statusLabel,
  title: "AuroraHome USA",
  tone,
});

export const merryCardMenuCatalog: MerryCardMenuCatalog = {
  account: {
    actions: [
      {
        iconSource: accountSettingsIcon,
        id: "account-information",
        label: "账号信息",
      },
      {
        iconSource: accountNotificationsIcon,
        id: "notification-management",
        label: "通知管理",
      },
    ],
    billingAction: {
      iconSource: accountTopupIcon,
      id: "plan-and-topup",
      label: "套餐与充值",
    },
    displayActions: [
      {
        iconSource: accountCurrencyIcon,
        id: "currency",
        label: "货币汇率",
        targetView: "currency",
        value: "USD",
      },
      {
        iconSource: accountLanguageIcon,
        id: "language",
        label: "语言地区",
        targetView: "language",
        value: "简体中文",
      },
    ],
    displayTitle: "显示方式",
    logoutAction: {
      iconSource: accountLogoutIcon,
      id: "logout",
      label: "退出登录",
    },
    metrics: [
      {
        iconSource: accountPackageProgress,
        id: "plan-points",
        label: "套餐积分",
        value: "2970 / 2970    100%",
      },
      {
        iconSource: accountRechargeProgress,
        id: "topup-points",
        label: "充值积分",
        value: "1090 / 3000    36%",
      },
    ],
    supportAction: {
      iconSource: accountSupportIcon,
      id: "support",
      label: "帮助与支持",
      targetView: "support",
    },
    title: "账户设置",
  },
  chatHistory: {
    newChatLabel: "新建聊天",
    searchPlaceholder: "筛选当前会话标题",
    sections: [
      {
        id: "pinned",
        label: "已置顶",
        items: [
          {
            id: "creator-follow-up",
            preview: "差评反馈 CloudWeave 防水沙发罩 Listing 优化 …",
            status: "complete",
            time: "04:47",
            title: "跟进 3 位高匹配家居达人",
          },
          {
            id: "prime-day",
            preview: "差评反馈 CloudWeave 防水沙发罩 Listing 优化 …",
            status: "question",
            time: "04:47",
            title: "Prime Day 大促日历",
          },
          {
            id: "strategy",
            preview: "差评反馈 CloudWeave 防水沙发罩 Listing 优化 …",
            status: "progress",
            title: "调整当前经营策略",
          },
          {
            id: "reviews",
            preview: "差评反馈 CloudWeave 防水沙发罩 Listing 优化 …",
            status: "dot",
            time: "04:47",
            title: "本周 31 条可归因差评 …",
          },
        ],
      },
      {
        id: "recent",
        label: "最近聊天",
        items: [
          {
            id: "flexifold-cart",
            preview: "差评反馈 CloudWeave 防水沙发罩 Listing 优化 …",
            status: "complete",
            time: "昨天",
            title: "FlexiFold 三层收纳车",
          },
          {
            id: "flexifold-stock",
            preview: "差评反馈 CloudWeave 防水沙发罩 Listing 优化 …",
            status: "complete",
            time: "昨天",
            title: "FlexiFold 补货判断",
          },
          {
            id: "bathroom-cabinet",
            preview: "差评反馈 CloudWeave 防水沙发罩 Listing 优化 …",
            status: "complete",
            time: "昨天",
            title: "浴室窄柜测品计划",
          },
        ],
      },
    ],
  },
  currency: {
    options: [
      { id: "CNY", label: "CNY" },
      { id: "USD", label: "USD" },
    ],
    title: "货币",
  },
  language: {
    options: [{ id: "zh-CN", label: "简体中文" }],
    title: "语言",
  },
  notifications: {
    markAllReadLabel: "全部已读",
    searchPlaceholder: "搜索通知内容",
    sections: [
      {
        id: "unread",
        label: "未读通知",
        items: [
          {
            description: "建议查看预算设置",
            id: "ad-budget",
            isUnread: true,
            time: "04:47",
            title: "广告消耗异常，建议查看预算设置",
            type: "abnormal",
          },
          {
            description: "可能影响本周销售目标",
            id: "low-stock",
            isUnread: true,
            time: "04:47",
            title: "3款热销产品库存不足",
            type: "warning",
          },
        ],
      },
      {
        id: "invitations",
        label: "邀约通知",
        items: [
          {
            description: "邀请你加入TikTok夏季美妆增长计划",
            id: "agency-invite",
            time: "04:47",
            title: "North America Growth Agency",
            type: "invite",
          },
        ],
      },
      {
        id: "read",
        label: "已读通知",
        items: [
          {
            description: "建议检查现有商品合规性",
            id: "policy-update",
            time: "04:47",
            title: "TikTokShop更新了商品审核政策",
            type: "notification",
          },
          {
            description: "CloudWeave 防水沙发罩 的包装与 …",
            id: "review-improvement-1",
            time: "04:47",
            title: "完成·差评改良事项",
            type: "notification",
          },
          {
            description: "CloudWeave 防水沙发罩 的包装与 …",
            id: "review-improvement-2",
            time: "04:47",
            title: "完成·差评改良事项",
            type: "notification",
          },
        ],
      },
    ],
  },
  store: {
    actions: [
      { iconSource: storeManageIcon, id: "store-management", label: "店铺管理" },
      { iconSource: storeTeamIcon, id: "team-management", label: "团队管理" },
      { iconSource: storeAdsIcon, id: "ads-management", label: "广告户管理" },
      { iconSource: storeTasksIcon, id: "task-management", label: "定时任务管理" },
    ],
    groups: [
      {
        id: "danger",
        label: "高危店铺",
        stores: [createStore("danger-store", "danger", "1高危 · 2待办")],
      },
      {
        id: "todo",
        label: "未处理代办",
        stores: [createStore("todo-store", "todo", "3待办")],
      },
      {
        id: "sync",
        label: "绑定/同步 异常",
        stores: [createStore("sync-store", "sync", "同步异常")],
      },
      {
        id: "stable",
        label: "经营平稳",
        stores: [
          createStore("stable-store-1", "default", "3待办"),
          createStore("stable-store-2", "default", "经营平稳"),
          createStore("stable-store-3", "default", "经营平稳"),
        ],
      },
    ],
    title: "配置管理",
  },
  support: {
    items: [],
    title: "帮助与支持",
  },
  widget: {
    actions: [
      { iconSource: widgetEditIcon, id: "widget-content", label: "组件内容" },
      {
        iconSource: widgetLayoutIcon,
        id: "widget-style",
        label: "组件风格",
        trailing: "arrow",
        trailingIconSource: widgetArrowRight,
        value: "简洁",
      },
    ],
    removeAction: {
      iconSource: widgetRemoveIcon,
      id: "widget-remove",
      label: "移除小组件",
    },
    title: "组件设置",
  },
};

// 仅供基础组件页展示设计状态；生产页面与顶部菜单从 API 获取条目。
export const merryCardMenuShowcaseCatalog: MerryCardMenuCatalog = {
  ...merryCardMenuCatalog,
  support: {
    ...merryCardMenuCatalog.support,
    items: [
      {
        description: "完整功能说明和操作指南",
        id: "documentation",
        label: "使用文档",
        trailing: "external",
      },
      {
        description: "工作日 9:00-18:00 在线支持",
        id: "customer-service",
        label: "联系客服",
      },
      {
        description: "申请历史订单发票或开具增值税发票",
        descriptionStyle: "multi",
        id: "invoice",
        label: "发票申请",
        trailing: "external",
      },
      {
        description: "最新功能更新与改进记录",
        id: "changelog",
        label: "更新日志",
        trailing: "external",
      },
    ],
  },
};
